'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));
var Autocomplete = _interopDefault(require('@material-ui/lab/Autocomplete'));
var KeyboardArrowDownIcon = _interopDefault(require('@material-ui/icons/KeyboardArrowDown'));
var styledComponents = require('./styled-components.js');

var AsyncMultiSelectWithTopLabel = function (props) {
    var _a = props.defaultValues, defaultValues = _a === void 0 ? [] : _a, _b = props.disableClearable, disableClearable = _b === void 0 ? false : _b, _c = props.disabled, disabledInput = _c === void 0 ? false : _c, _d = props.error, error = _d === void 0 ? false : _d, fetchData = props.fetchData, _e = props.fetchFilterOnly, fetchFilterOnly = _e === void 0 ? false : _e, id = props.id, _f = props.keepOpenOnSelect, keepOpenOnSelect = _f === void 0 ? false : _f, limitTags = props.limitTags, onBlur = props.onBlur, _g = props.placeholder, placeholder = _g === void 0 ? '' : _g, reporter = props.reporter, title = props.title;
    var _h = React.useState(false), open = _h[0], setOpen = _h[1];
    var _j = React.useState(false), loading = _j[0], setLoading = _j[1];
    var _k = React.useState([]), options = _k[0], setOptions = _k[1];
    var _l = React.useState(defaultValues), selected = _l[0], setSelected = _l[1];
    var _m = React__default.useState(''), inputValue = _m[0], setInputValue = _m[1];
    var onChange = function (event, value, reason) {
        if (reason === 'remove-option') {
            // need to find what is being removed, to see if it's allowed (!disabled)
            var removedItem = selected.filter(function (item) { return !value.includes(item); });
            if (removedItem.length > 0 && removedItem[0].disabled) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
        }
        setSelected(value);
        reporter(event, value);
    };
    var handleDelete = function (event, itemToRemove) {
        event.preventDefault();
        event.stopPropagation();
        var newItems = selected.filter(function (item) {
            var value = typeof item.value === 'string' || typeof item.value === 'number'
                ? item.value
                : item.value.id;
            return value !== itemToRemove;
        });
        onChange(event, newItems);
    };
    React.useEffect(function () {
        var active = true;
        if (!open) {
            setLoading(false);
            return undefined;
        }
        (function () { return tslib.__awaiter(void 0, void 0, void 0, function () {
            var results;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, fetchData(inputValue)];
                    case 1:
                        results = _a.sent();
                        if (active) {
                            setOptions(tslib.__spreadArrays(defaultValues, results) || []);
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            active = false;
        };
    }, [open, inputValue]);
    React.useEffect(function () {
        if (!open) {
            setOptions([]);
        }
    }, [open]);
    var filterOptions = fetchFilterOnly
        ? function (menuItems) { return menuItems; }
        : undefined;
    var autoCompleteId;
    var textFieldId;
    if (id) {
        autoCompleteId = id;
        textFieldId = id + "-text-field";
    }
    var inputPlaceholder;
    if (selected.length === 0) {
        inputPlaceholder = placeholder;
    }
    var _o = React.useState(false), focused = _o[0], setFocused = _o[1];
    var handleFocus = function () {
        setFocused(true);
    };
    var handleBlur = function (event) {
        setFocused(false);
        if (onBlur)
            onBlur(event);
    };
    return (React__default.createElement(styledComponents.Main, null,
        title && React__default.createElement(styledComponents.StyledInputLabel, null, title),
        React__default.createElement(Autocomplete, { id: autoCompleteId, "data-testid": 'async-autocomplete', multiple: true, open: open, disabled: disabledInput, onOpen: function () {
                setOpen(true);
            }, onClose: function (event, reason) {
                if (keepOpenOnSelect && reason === 'select-option') {
                    return;
                }
                setOpen(false);
            }, inputValue: inputValue, onInputChange: function (e, newInputValue) { return setInputValue(newInputValue); }, getOptionSelected: function (option, value) {
                if (typeof option.value === 'string' || typeof option.value === 'number') {
                    return option.value === value.value;
                }
                return option.value.id === value.value.id;
            }, filterOptions: filterOptions, filterSelectedOptions: true, getOptionLabel: function (option) { return option.display; }, disableClearable: disableClearable, options: options, loading: loading, popupIcon: React__default.createElement(KeyboardArrowDownIcon, null), value: selected, onChange: onChange, renderOption: function (option) { return (React__default.createElement("div", { className: option.disabled ? 'disabled' : '' }, option.display)); }, renderTags: function (selectedItems) { return (React__default.createElement(styledComponents.StyledParentContainer, null,
                selectedItems.slice(0, focused ? undefined : limitTags).map(function (item) {
                    var stringValue = typeof item.value === 'string';
                    var value = stringValue
                        ? item.value
                        : item.value.id;
                    return (React__default.createElement(styledComponents.StyledChip, { key: value, label: item.display, size: 'small', disabled: disabledInput, onDelete: item.disabled ? undefined : function (e) { return handleDelete(e, value); } }));
                }),
                limitTags && selected.length > limitTags && !focused && (React__default.createElement(SmallDarkText, { component: 'span' },
                    "+",
                    selectedItems.length - limitTags,
                    " ",
                    placeholder)))); }, getOptionDisabled: function (option) { return option.disabled || false; }, renderInput: function (params) {
                return (React__default.createElement(styledComponents.StyledTextField
                // eslint-disable-next-line react/jsx-props-no-spreading
                , tslib.__assign({}, params, { id: textFieldId, error: error, onBlur: handleBlur, onFocus: handleFocus, placeholder: inputPlaceholder, variant: 'outlined', disabled: disabledInput, "data-testid": 'async-text-field', InputProps: tslib.__assign(tslib.__assign({}, params.InputProps), { endAdornment: (React__default.createElement(React__default.Fragment, null,
                            loading ? React__default.createElement(CircularProgress, { color: 'inherit', size: 17 }) : null,
                            params.InputProps.endAdornment)) }) })));
            } })));
};

module.exports = AsyncMultiSelectWithTopLabel;
